module.exports = __webpack_public_path__ + "img/1.1.0279fcac.png";